// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"88bfad79","879":"6a0edee8"}[chunkId] + ".chunk.js";
};